function generateLinkBaseForEnvironment() {
  // detect domain and subdomain, including protocol and port (if given)
  const origin = window.location.origin;
  if (origin.match("localhost:")) {
    return "https://tarifrechner-i.vis-extranet.de/";
  }
  return origin + "/";
}

/**
 * HUS-BVG liegt im Formular-Center (SFA), nicht mehr in FormularDBNew.
 * Mapping: Tarifrechner-Origin → SFA-Umgebung.
 */
const HUS_BVG_DOWNLOAD_ID = "a7c6d31b-d3a1-4239-8a8d-07d359608119";
const HUS_BVG_DOWNLOAD_PATH =
  "/srv/formular-center2/download/" + HUS_BVG_DOWNLOAD_ID;

const HUS_BVG_SFA_BASE_BY_ORIGIN = {
  "https://bitve191.vis-extranet.de": "https://entw.sfa.oeffentliche.de",
  "https://bitvk191.vis-extranet.de": "https://kons.sfa.oeffentliche.de",
  "https://tarifrechner-i.vis-extranet.de": "https://inte.sfa.oeffentliche.de",
  "https://tarifrechner.vis-extranet.de": "https://sfa.oeffentliche.de"
};

function resolveAppOrigin() {
  const origin = window.location.origin;
  if (origin.match("localhost:")) {
    return "https://tarifrechner-i.vis-extranet.de";
  }
  return origin;
}

function generateHusBvgLink() {
  const appOrigin = resolveAppOrigin();
  const sfaBase =
    HUS_BVG_SFA_BASE_BY_ORIGIN[appOrigin] ||
    HUS_BVG_SFA_BASE_BY_ORIGIN["https://tarifrechner.vis-extranet.de"];
  return sfaBase + HUS_BVG_DOWNLOAD_PATH;
}

let environmentLinkBase = generateLinkBaseForEnvironment();
let husBvgLink = generateHusBvgLink();

export { husBvgLink };
export default environmentLinkBase;
